<mat-card [appearance]="'outlined'" [class]="'value-prop-item tw-h-full'" [class.edit-mode]="editMode">
  <div class="d-flex justify-content-between">
    <div class="tw-p-2">
      <div class="tw-text-sm tw-mt-1 tw-mb-1">{{ valueProp.title }}</div>
      <div class="tw-text-xs tw-text-gray-500 tw-mb-1">{{ valueProp.description }}</div>
    </div>
    <mat-card-actions *ngIf="editMode" class="align-items-start actions">
      <div class="material-icons drag-handle tw-mr-1" cdkDragHandle><mat-icon>open_with</mat-icon></div>
      <button class="material-icons remove-button" (click)="removeItem()"><mat-icon>clear</mat-icon></button>
    </mat-card-actions>
  </div>
</mat-card>
